<div *ngIf="node.type === 'folder'" [style.cursor]="'pointer'" class="node-li">
  <!-- Gestione delle icone per l'espansione della cartella -->
  <ng-container *ngIf="shouldShowIcon(node); else noIcon">
    <mat-icon aria-hidden="true" (click)="toggleNode(node)" *ngIf="!node.expanded" class="color-grey">
      keyboard_arrow_right
    </mat-icon>
    <mat-icon aria-hidden="true" (click)="toggleNode(node)" *ngIf="node.expanded" class="color-grey">
      keyboard_arrow_down
    </mat-icon>
  </ng-container>

  <!-- Icone della cartella -->
  <ng-container>
    <mat-icon aria-hidden="true" *ngIf="!node.expanded" class="color-yellow">folder</mat-icon>
    <mat-icon aria-hidden="true" *ngIf="node.expanded" class="color-yellow">folder_open</mat-icon>
  </ng-container>

  <!-- Nome del nodo e gestione drag & drop -->
  <div
    appDropZone
    #nodeItem
    (dragover)="onDragOver($event)"
    (click)="nodesEmitter(node)"
    (drop)="onDrop($event, nodeItem)"
    class="name"
  >
    {{ node.name }}
  </div>
</div>

<!-- GESTIONE RICORSIVA: se la cartella è espansa e ha figli, mostra i sotto-nodi -->
<ul *ngIf="node.expanded && node.children?.length > 0" class="m-2 p-0">
  <li *ngFor="let child of node.children">
    <app-fs-tree-node
      [node]="child"
      (nodesHandler)="nodesHandler.emit($event)"
      (dropHandler)="dropHandler.emit($event)"
    ></app-fs-tree-node>
  </li>
</ul>

<ng-template #noIcon>
  <mat-icon aria-hidden="true"></mat-icon>
</ng-template>
